import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext({
  language: 'Dutch',
  setLanguage: () => {}
});

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  const { i18n } = useTranslation();

  return {
    language: i18n.language === 'nl' ? 'Dutch' : 'English',
    setLanguage: (newLang) => {
      const langCode = newLang === 'Dutch' ? 'nl' : 'en';
      i18n.changeLanguage(langCode);
    }
  };
};